import React from "react";
import './TabItem.css';
import { motion } from 'framer-motion';
import PostsList from "../../components/Blogs/HomePage";

const blogs = [
  {
    imgUrl: "./img/services/ui-ux/user-research.png",
    imgAlt: "A laptop displaying code for web development",
    title: "Top 10 Web Development Frameworks in 2024",
    date: "2024-12-01",
    excerpt: "Explore the best web development frameworks of 2024 that simplify building dynamic and responsive websites."
  },
  {
    imgUrl: "./img/services/ui-ux/usability-testing.png",
    imgAlt: "Person coding on a desktop computer",
    title: "The Future of Web Development: Trends to Watch",
    date: "2024-11-20",
    excerpt: "Discover the latest trends and technologies shaping the future of web development."
  },
  {
    imgUrl: "./img/services/responsive-website/cross-browser-compatibility.jpg",
    imgAlt: "A close-up of a developer working on JavaScript",
    title: "Understanding JavaScript ES2024 Features",
    date: "2024-11-15",
    excerpt: "Dive into the newest features introduced in ES2024 and how they can optimize your JavaScript code."
  },
  {
    imgUrl: "./img/services/responsive-website/perfomance-optimization.png",
    imgAlt: "A responsive web design layout on multiple devices",
    title: "Responsive Design Tips for Modern Websites",
    date: "2024-10-30",
    excerpt: "Learn essential tips for creating websites that look great on all devices."
  },
  {
    imgUrl: "./img/services/responsive-website/cross-browser-compatibility.jpg",
    imgAlt: "A designer planning a user interface",
    title: "UI/UX Best Practices for Web Developers",
    date: "2024-10-10",
    excerpt: "Understand key principles of UI/UX design that every web developer should know."
  },
  {
    imgUrl: "./img/services/web-security/secure-apis.jpg",
    imgAlt: "A website built with React.js",
    title: "Why React Remains a Top Choice for Web Development",
    date: "2024-09-25",
    excerpt: "Learn why React continues to dominate the web development landscape and how to leverage its ecosystem."
  },
  {
    imgUrl: "./img/services/web-security/regular-security-updates.jpg",
    imgAlt: "Code editor with backend APIs",
    title: "Building Secure and Scalable Backend APIs",
    date: "2024-09-10",
    excerpt: "A comprehensive guide to creating secure and scalable APIs for your web applications."
  },
  {
    imgUrl: "./img/services/web-security/secure-authenciation.jpg",
    imgAlt: "A team collaborating on a website project",
    title: "Collaboration Tools for Web Development Teams",
    date: "2024-08-20",
    excerpt: "Explore the best tools for improving collaboration and productivity in web development projects."
  },
  {
    imgUrl: "./img/services/seo-optimization/higher-roi.png",
    imgAlt: "SEO analytics dashboard",
    title: "SEO for Web Developers: A Complete Guide",
    date: "2024-08-05",
    excerpt: "Learn how to optimize your websites for search engines and improve visibility in 2024."
  },
  {
    imgUrl: "./img/services/seo-optimization/increased-website-traffic.png",
    imgAlt: "Web accessibility testing tools",
    title: "Web Accessibility: Making Your Sites Inclusive",
    date: "2024-07-15",
    excerpt: "Understand the importance of web accessibility and how to implement inclusive design principles."
  }
];


const WebDevelopment = () => {
  return (
    <motion.div
      key="div0"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      transition={{ duration: 0.7 }}
    >
      <PostsList data={blogs} />
    </motion.div>
  );
};

export default WebDevelopment;
